import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription , of } from 'rxjs';
import { SidebarService } from '@services/sidebar.service';
import { ContextInfoUser } from '@model/webFeeder/context-info-user';

@Component({
  selector: 'app-broker-authentication',
  templateUrl: './broker-authentication.component.html',
})

export class BrokerAuthenticationComponent implements OnInit, OnDestroy {

  public loadingSimulator: boolean;
  public loadingBroker: boolean;
  public showAuth: boolean;
  public showAuthBroker: boolean;
  public showAuthSimulator: boolean;
  public model: any = {};
  public clickOpenTabOrder: Subscription;
  public tabClickCallBack: number;
  public isMultiBroker: boolean = false;
  public multiBrokerSelected: ContextInfoUser;

  constructor(
    public _dialogRef: MatDialogRef<BrokerAuthenticationComponent>,
    private _configSerice: ConfigService,
    private sidebarService: SidebarService,
  ) {
    this.showAuth = true;
    this.showAuthBroker = false;
    this.showAuthSimulator = false;
    this.isMultiBroker = this._configSerice.isMultiBroker();
    if (this.isMultiBroker) {
      this.multiBrokerSelected = this._configSerice.getConfigMultibroker();
      if (this.multiBrokerSelected.usersBrokerName) {
        this.openAuthBroker();
        this.showAuthBroker = true;
        this.showAuth = false;
      }
    }
  }

  ngOnInit() {
    this.clickOpenTabOrder = this.sidebarService.clickOpenTabAuthCallBack$
      .subscribe(x => {
        if (x) {
          this.tabClickCallBack = x;
        }
      });
  }

  ngOnDestroy() {
    this.tabClickCallBack = 0;
  }

  closeClick(): void {
    this._dialogRef.close();
  }

  backClick() {
    this.showAuth = true;
    this.showAuthBroker = false;
    this.showAuthSimulator = false;
  }

  openAuthBroker() {
    this.showAuth = false;
    this.showAuthBroker = true;
    this.showAuthSimulator = false;
  }

}
